import "./scripts/card";

import "./styles/card.scss";
